import { useSyncExternalStore } from "react";
//#region src/hooks/use-visual-viewport.ts
const getVisualViewportLayerStyle = ({ bottomInset, height, offsetTop }) => bottomInset > 0 ? {
	top: offsetTop,
	height
} : void 0;
const serverState = {
	height: 0,
	offsetTop: 0,
	scale: 1,
	bottomInset: 0
};
const readIdleVisualViewport = () => ({
	height: typeof window === "undefined" ? 0 : window.innerHeight,
	offsetTop: 0,
	scale: 1,
	bottomInset: 0
});
/** Measure the visual viewport once, outside React, so derived layout math stays unit-testable. */
const readVisualViewport = () => {
	const viewport = typeof window === "undefined" ? void 0 : window.visualViewport;
	if (!viewport) return readIdleVisualViewport();
	const { height, offsetTop, scale } = viewport;
	return {
		height,
		offsetTop,
		scale,
		bottomInset: scale > 1 ? 0 : Math.max(0, Math.round(window.innerHeight - offsetTop - height))
	};
};
const isSameViewport = (a, b) => a.height === b.height && a.offsetTop === b.offsetTop && a.scale === b.scale && a.bottomInset === b.bottomInset;
let liveSnapshot = serverState;
let idleSnapshot = serverState;
const getLiveSnapshot = () => {
	const next = readVisualViewport();
	if (!isSameViewport(liveSnapshot, next)) liveSnapshot = next;
	return liveSnapshot;
};
const getIdleSnapshot = () => {
	const next = readIdleVisualViewport();
	if (!isSameViewport(idleSnapshot, next)) idleSnapshot = next;
	return idleSnapshot;
};
const getServerSnapshot = () => serverState;
const subscribeToVisualViewport = (onChange) => {
	if (typeof window === "undefined") return () => {};
	const viewport = window.visualViewport;
	viewport?.addEventListener("resize", onChange);
	viewport?.addEventListener("scroll", onChange);
	window.addEventListener("resize", onChange);
	return () => {
		viewport?.removeEventListener("resize", onChange);
		viewport?.removeEventListener("scroll", onChange);
		window.removeEventListener("resize", onChange);
	};
};
const subscribeToNothing = () => () => {};
/**
* Track the visual viewport, which is the only viewport that shrinks when the on-screen keyboard
* opens on iOS Safari and Android Chrome. Use `bottomInset` to lift `position: fixed` UI above it.
*/
const useVisualViewport = ({ enabled = true } = {}) => useSyncExternalStore(enabled ? subscribeToVisualViewport : subscribeToNothing, enabled ? getLiveSnapshot : getIdleSnapshot, getServerSnapshot);
//#endregion
export { getVisualViewportLayerStyle, readVisualViewport, useVisualViewport };

//# sourceMappingURL=use-visual-viewport.js.map